import React, { useState, useEffect } from "react";
import {
  LoginContainer,
  LoginCard,
  Title,
  TabsContainer,
  Tab,
  LogoImg,
} from "./Login.styles.js";

import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import logoImage from "../../images/logo_ylhq.png";

function AuthContainer() {
  const [activeTab, setActiveTab] = useState("login");

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (hash === "register") {
        setActiveTab("register");
      } else if (hash === "forgot-password") {
        setActiveTab("forgot-password");
      } else {
        setActiveTab("login");
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const switchTab = (tab) => {
    setActiveTab(tab);
    window.location.hash = `#${tab}`;
  };

  const renderForm = () => {
    switch (activeTab) {
      case "login":
        return (
          <LoginForm
            switchToForgotPassword={() => switchTab("forgot-password")}
          />
        );
      case "register":
        return <RegisterForm switchToLogin={() => switchTab("login")} />;
      case "forgot-password":
        return <ForgotPasswordForm switchToLogin={() => switchTab("login")} />;
      default:
        return <LoginForm />;
    }
  };

  return (
    <LoginContainer>
      <LoginCard>
        <LogoImg src={logoImage} alt="Yellow Letter HQ Logo" />
        <Title>Admin Dashboard</Title>

        <TabsContainer>
          <Tab
            active={activeTab === "login"}
            onClick={() => switchTab("login")}
          >
            Login
          </Tab>
          <Tab
            active={activeTab === "register"}
            onClick={() => switchTab("register")}
          >
            Sign Up
          </Tab>
        </TabsContainer>

        {renderForm()}
        <p
          active={activeTab === "forgot-password"}
          onClick={() => switchTab("forgot-password")}
          style={{
            fontSize: "14px",
            color: "#888",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          Forget Password?
        </p>
      </LoginCard>
    </LoginContainer>
  );
}

export default AuthContainer;
